import { AUTH_PATHS } from './auth'
import { ORDER_PATHS } from './orders'
import { ROUTES, SHOP_ROUTES } from './routes'
import { WHATSAPP_HREF } from './site-actions'

export type FooterLink = {
  label: string
  to?: string
  comingSoon?: boolean
}

export type FooterColumn = {
  title: string
  links: readonly FooterLink[]
}

export const FOOTER_COMING_SOON_LABEL = 'Coming soon'

export const FOOTER_COLUMNS: readonly FooterColumn[] = [
  {
    title: 'Shop',
    links: [
      { label: 'Flowers', to: SHOP_ROUTES.flowers },
      { label: 'Plants', to: SHOP_ROUTES.plants },
      { label: 'Combos', to: SHOP_ROUTES.flowerChocolateCombo },
      { label: 'Cakes', comingSoon: true },
      { label: 'Occasions', to: SHOP_ROUTES.occasions },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About Us', to: ROUTES.about },
      { label: 'Locations', to: ROUTES.locations },
      { label: 'Blog', to: ROUTES.blog },
      { label: 'Become a Vendor', to: ROUTES.vendorRegistration },
      { label: 'Corporate Gifting', to: ROUTES.corporateEnquiry },
      { label: 'Contact', to: ROUTES.contact },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'FAQs', to: ROUTES.faqs },
      { label: 'Your Account', to: AUTH_PATHS.profile },
      { label: 'Order Tracking', to: ORDER_PATHS.list },
      { label: 'Returns & Refunds', to: ROUTES.returns },
      { label: 'Privacy Policy', to: ROUTES.privacy },
      { label: 'Terms & Conditions', to: ROUTES.terms },
      { label: 'Disclaimer', to: ROUTES.disclaimer },
    ],
  },
] as const

export const FOOTER_COPY = {
  kicker: [
    "India's 1st Florist Aggregator",
    "India's Hyperlocal Florist Marketplace",
  ],
  blurb:
    'Connecting you with local florists and growers for farm-fresh flowers, plants and gifting — delivered in as little as 60 minutes across 80+ cities.',
  tagline: 'Buy Local. Support Local. Bloom Local.',
  note: '60-min delivery · Free gift wrap · Local florists',
  company: 'Maaliondoor Services Pvt. Ltd.',
} as const

export const SOCIAL_ICON_SIZE = 22

export const SOCIAL_LINKS = [
  {
    label: 'WhatsApp',
    href: WHATSAPP_HREF,
    iconSrc: '/images/social/whatsapp.svg',
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/maaliondoor_/',
    iconSrc: '/images/social/instagram.svg',
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/maaliondoor',
    iconSrc: '/images/social/facebook.svg',
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/maaliondoor',
    iconSrc: '/images/social/linkedin.svg',
  },
] as const
